import { render } from "./EspacoList.vue?vue&type=template&id=b0056b92"
import script from "./EspacoList.vue?vue&type=script&lang=js"
export * from "./EspacoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__